import { render, staticRenderFns } from "./product-finish-tab.vue?vue&type=template&id=85ce7836&scoped=true&"
import script from "./product-finish-tab.vue?vue&type=script&lang=js&"
export * from "./product-finish-tab.vue?vue&type=script&lang=js&"
import style0 from "./product-finish-tab.vue?vue&type=style&index=0&id=85ce7836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ce7836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85ce7836')) {
      api.createRecord('85ce7836', component.options)
    } else {
      api.reload('85ce7836', component.options)
    }
    module.hot.accept("./product-finish-tab.vue?vue&type=template&id=85ce7836&scoped=true&", function () {
      api.rerender('85ce7836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/product-finishes-slider/components/product-finish-tab.vue"
export default component.exports